/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Linux_Arm_Rpm_DescInputs */

const en_pc_dl_file_linux_arm_rpm_desc = /** @type {(inputs: Pc_Dl_File_Linux_Arm_Rpm_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedora, RHEL and openSUSE on ARM.`)
};

const zh_pc_dl_file_linux_arm_rpm_desc = /** @type {(inputs: Pc_Dl_File_Linux_Arm_Rpm_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于 ARM 上的 Fedora、RHEL 和 openSUSE。`)
};

/**
* | output |
* | --- |
* | "Fedora, RHEL and openSUSE on ARM." |
*
* @param {Pc_Dl_File_Linux_Arm_Rpm_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_linux_arm_rpm_desc = /** @type {((inputs?: Pc_Dl_File_Linux_Arm_Rpm_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Linux_Arm_Rpm_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_linux_arm_rpm_desc(inputs)
	return zh_pc_dl_file_linux_arm_rpm_desc(inputs)
});
export { pc_dl_file_linux_arm_rpm_desc as "pc.dl.file.linux_arm_rpm.desc" }